import React from 'react';
import PropTypes from 'prop-types';

/**
 * A component for displaying system messages
 */
function Notice({ type = 'info', headline, children }) {
  return (
    <div
      className={`notice notice--${type}`}
      role="alert"
      aria-live={type === 'warning-alert' || type == 'cta' ? 'assertive' : 'polite'}
      style={{ textAlign: 'left' }}
    >
      {headline && <p className="notice__headline">{headline}</p>}
      {children}
    </div>
  );
}

Notice.propTypes = {
  /**
   * The type of message to display
   */
  type: PropTypes.oneOf(['info', 'info-icon', 'warning-alert', 'positive', 'migration']),
  /**
   * The optional headline contents
   */
  headline: PropTypes.string,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default Notice;
